function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  flex-wrap: wrap;\n  flex-flow: row wrap;\n  margin: 20px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React, { Component } from "react";
import Category from "../category/category";
import { withContext } from "../../wr-context";
import { Row, Col } from "../../grid";
import styled from "styled-components";
var CategoriesContainer = styled.div(_templateObject());
var CategoriesRow = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(CategoriesRow, Component);
    var _super = _createSuper(CategoriesRow);
    function CategoriesRow() {
        _classCallCheck(this, CategoriesRow);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            selectedCategories: []
        };
        _this.selectCategory = function(selectedCategory) {
            var context = _this.props.context;
            var selectedCategories = _this.state.selectedCategories;
            var categoryIsSelected = selectedCategories.find(function(cat) {
                return cat === selectedCategory;
            });
            if (categoryIsSelected) {
                selectedCategories = selectedCategories.filter(function(category) {
                    return category !== selectedCategory;
                });
            } else {
                selectedCategories.push(selectedCategory);
            }
            context.actions.updateCategoryFilters(selectedCategory);
            _this.setState({
                selectedCategories: selectedCategories
            });
        };
        return _this;
    }
    var _proto = CategoriesRow.prototype;
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, context = _props.context, _colSize = _props.colSize, colSize = _colSize === void 0 ? {
            xs: 12
        } : _colSize;
        var categories = context.state.categories;
        var selectedCategories = this.state.selectedCategories;
        if (!categories.length) return null;
        var updatedCategories = categories.filter(function(category) {
            return category.id !== "category-undefined";
        });
        return /*#__PURE__*/ React.createElement(Row, {
            middle: "xs",
            center: "xs"
        }, /*#__PURE__*/ React.createElement(Col, _extends({}, colSize), /*#__PURE__*/ React.createElement(CategoriesContainer, null, updatedCategories.map(function(category, index) {
            return /*#__PURE__*/ React.createElement(Category, {
                key: index,
                selectedCategories: selectedCategories,
                selectCategory: _this.selectCategory,
                category: category
            });
        }))));
    };
    return CategoriesRow;
}(Component);
export default withContext(CategoriesRow);
